/* eslint-disable indent */
/* eslint-disable no-throw-literal */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useActions } from '../../store/hooks/useActions';
import { apiEndPoints, rootConfig } from '../../services/axios/endPoints';
import { sagaCatchBlockHandling } from '../../store/utility/sagaErrorHandling';
import { WebService } from '../../services/axios/webServices';
import {
  convertFormInputObjToSimple,
  getFieldDependents,
  validateFields
} from '../Common/GenericForm/utils';
import { INPUT_TYPES } from '../../constants';
import ProfileHeader from '../../views/Profile/ProfileHeader';
import { isEmpty } from '../../shared/utility/isEmpty';
import Loader from '../Common/Loader/Loader';
import { BodyContainer } from './ProfileDetailsForm.styles';
import GenericForm from '../Common/GenericForm/GenericForm';
import Toast from '../Common/Toast';

const ProfileDetailsForm = () => {
  const locations = useLocation();
  const navigate = useNavigate();
  const { state } = locations;

  const profileDetailsFormRef = useRef();

  const [loading, setLoading] = useState(false);
  const [formInput, setFormInput] = useState({});
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [spareSavePermissionInfo, setspareSavePermissionInfo] = useState({});
  const [spareformStructure, setSpareformStructure] = useState([]);
  const { profilePermissions } = useSelector((state) => state.profileDetails);

  const { setToastError } = useActions();

  const {
    isFormEditable,
    isFormChangePass = false,
    formInput: formInputProp,
    areFormInputsChanged,
    formApi,
    saveForm
  } = state;

  const isEdit = saveForm === `${apiEndPoints.updateSpare}/update`;

  useEffect(() => {
    if (isFormChangePass) {
      setLoading(true);
      WebService.get(`${formApi}/${formInputProp?.UserID}`)
        .then((res) => {
          const { status, data } = res;
          if (status >= 200 && status < 300) {
            setSpareformStructure(data);
          } else {
            throw res.data;
          }
        })
        .catch((e) => {
          const { error } = sagaCatchBlockHandling(e);
          setToastError(error);
        })
        .finally(() => {
          setLoading(false);
        });
      setFormInput(formInputProp);
    } else {
      setLoading(true);
      WebService.get(formApi)
        .then((res) => {
          const { status, data } = res;
          if (status >= 200 && status < 300) {
            setSpareformStructure(data);
          } else {
            throw res.data;
          }
        })
        .catch((e) => {
          const { error } = sagaCatchBlockHandling(e);
          setToastError(error);
        })
        .finally(() => {
          setLoading(false);
        });
      setFormInput(formInputProp);
    }
    // }
  }, [formInputProp]);

  useEffect(() => {
    spareformStructure?.forEach((user) => {
      if (Object.keys(user)?.includes('isSave')) {
        if (user?.isSave) {
          setspareSavePermissionInfo({ ...user });
        }
      }
    });
  }, [spareformStructure]);

  const handleSpareEdit = () => {
    navigate('/home/Stores/Profile/edit', {
      state: {
        isFormEditable: true,
        formInput,
        formApi: `${apiEndPoints.getEquipmentForm}/UpdateSpareForm`,
        saveForm: `${apiEndPoints.updateSpare}/update`
      }
    });
  };

  const handleSave = () => {
    const localFormInput = profileDetailsFormRef.current.getFormInput();
    try {
      const isPassed = validateFields(spareformStructure, localFormInput);
      if (!isPassed) {
        throw 'Validation error has occurred';
      }
      // console.log('localFormInput', localFormInput);
      const formatedFormInput = convertFormInputObjToSimple(localFormInput);
      const requiredInput = spareformStructure.reduce((acc, e) => {
        const { key, inputType, defaultValue } = e;
        let val =
          formatedFormInput[key] === undefined
            ? defaultValue
            : formatedFormInput[key];
        if (inputType === INPUT_TYPES.TOGGLE) {
          val = val || false;
        }
        if (!key) return acc;
        return { ...acc, [key]: val };
      }, {});
      WebService.post(saveForm, requiredInput)
        .then((res) => {
          const { data, status } = res;
          if (status >= 200 && status < 300) {
            setFormInput(localFormInput);
            navigate('/home/Stores/Profile', {
              state: {
                isFormEditable: false,
                formInput: localFormInput,
                areFormInputsChanged: true,
                formApi,
                saveForm
              }
            });
          } else {
            throw res;
          }
        })
        .catch((e) => {
          const { error } = sagaCatchBlockHandling(e);
          console.log('error===', error);
          setToastError(error);
        });
    } catch (e) {
      console.log('error--', e);
      setToastError(e);
    }
  };

  const handleCancel = () => {
    if (isEdit) {
      navigate('/home/Stores/Profile/details', {
        state: {
          isFormEditable: false,
          formInput: formInputProp,
          formApi,
          saveForm
        }
      });
    } else {
      navigate('/home/Stores/Profile', {
        state: { record: areFormInputsChanged ? formInput : {} }
      });
    }
  };

  const handleBack = () => {
    // if in details page go back to users
    if (!isFormEditable) {
      navigate('/home/Stores/Profile', {
        state: { record: areFormInputsChanged ? formInput : {} }
      });
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <ProfileHeader
        title={
          !isFormEditable
            ? 'Spare details'
            : `${isEdit ? 'Edit' : 'Add'} Spare Details`
        }
        isFormEditable={isFormEditable}
        handleProfileEdit={handleSpareEdit}
        handleSave={handleSave}
        isSaveEnabled={
          !isEmpty(spareSavePermissionInfo)
            ? spareSavePermissionInfo?.isSave === 'Y' && isFormFilled
            : isFormFilled
        }
        handleCancel={handleCancel}
        canEdit={profilePermissions?.CanEdit}
        handleBack={handleBack}
      />
      <BodyContainer>
        {loading ? (
          <Loader />
        ) : (
          <GenericForm
            isFormEditable={isFormEditable}
            formStructure={spareformStructure}
            ref={profileDetailsFormRef}
            formInput={formInput}
            setFormInput={setFormInput}
            showHeader
            setIsFormFilled={setIsFormFilled}
            formStructureFieldDepenents={getFieldDependents(spareformStructure)}
            allowHorizontal={false}
            isUser={true}
            ignoreWidth={true}
            baseUrlConfig={`${rootConfig.apiRoot1}/User`}
          />
        )}
        {!isEmpty(spareSavePermissionInfo) &&
          spareSavePermissionInfo?.isSave !== 'Y' && (
            <Toast
              message={spareSavePermissionInfo?.displayMsg || ''}
              header='Error'
              style={{ right: 30, bottom: 30 }}
            />
          )}
      </BodyContainer>
    </>
  );
};

export default ProfileDetailsForm;
